import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, Input, HostListener } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.css"]
})
export class BlogHomeComponent implements OnInit, OnDestroy {
    blogPost: Observable<any[]>
    categories: Observable<any[]>;

    constructor(private afs: AngularFirestore) {

    }
    async ngOnInit() {
        this.blogPost = await this.afs.collection('blog', ref => ref.orderBy('modifyDate')).snapshotChanges().pipe(map(actions => {
            return actions.map(a => {
                return {
                    id: a.payload.doc.id,
                    ...a.payload.doc.data()
                }
            });
        }));
        this.categories = await this.afs.collection('blogCategories').valueChanges();

    }
    ngOnDestroy() { }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/blog-page/home/home.component.ts